











































































































import Vue from "vue";
import EditForm from "./components/EditForm.vue";
import _ from "lodash";

import {
  ROfListOfAuthorityDomainTreeDto,
  AuthorityDomainServiceProxy
} from "@/service-proxies/app-v2/system.service-proxies";

const serviceProxy = new AuthorityDomainServiceProxy();

export default Vue.extend({
  components: {
    EditForm
  },
  data() {
    return {
      visible: false,
      detailshow: false,
      loading: false,
      showAddModal: false,
      dataSource: [],
      columns: [
        {
          title: this.$t("page_authority_jurisdiction_name"),
          dataIndex: "data.deptName",
          key: "data.deptName",
          width: 350
        },
        {
          title: this.$t("page_authority_jurisdiction_action"),
          key: "action",
          scopedSlots: { customRender: "action" },
          width: 198
        },
        {
          width: 520,
          title: this.$t("page_authority_jurisdiction_remark"),
          dataIndex: "data.remark",
          key: "data.remark"
        },
        {
          title: this.$t("page_authority_jurisdiction_sort"),
          dataIndex: "data.sort",
          key: "data.sort",
          width: 200
        },
        {
          title: this.$t("page_authority_jurisdiction_enable_disable"),
          dataIndex: "data.isEnable",
          key: "data.isEnable",
          width: 120,
          scopedSlots: { customRender: "enable" }
        }
      ],
      editdata: {}
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    handleadd() {
      this.detailshow = false;
      this.$nextTick(() => {
        this.editdata = {};
        this.showAddModal = true;
      });
    },
    rowClick(item: any) {
      return {
        on: {
          click: (row: any) => {
            this.editdata = Object.assign({}, item, item.data);
            // this.detailshow = true;
          }
        }
      };
    },
    handleEdit(record: any) {
      if (this.detailshow) {
        this.$confirm({
          title: this.$t('switch_tips_title'),
          content: this.$t('switch_tips_content'),
          onOk: () => {
            this.editdata = Object.assign({}, record, record.data);
            this.detailshow = true;
          },
          onCancel() {
            return;
          }
        });
      } else {
        this.editdata = Object.assign({}, record, record.data);
        this.detailshow = true;
      }
    },
    async onDelete({ id }: any) {
      await serviceProxy.remove([id]);
      this.$message.success(this.$t("delete_success"));
      this.getData();
    },
    onApply(type: any) {
      this.$refs[type].form.validateFields((err: any, values: any) => {
        if (err) return;
        const data = values;
        if (type === "edit") data.id = this.editdata.id;

        // 需要转换为数字
        data.isEnable = values.isEnable ? 1 : 0;
        serviceProxy.submit(data).then(() => {
          this.$message.success(this.$t("save_success"));
          this.detailshow = false;
          this.showAddModal = false;
          this.getData();
        });
      });
    },
    async getData() {
      const res: ROfListOfAuthorityDomainTreeDto = await serviceProxy.treeList();
      const data = res.data;
      const arr = this.filterData(data);
      console.log("arr", arr);
      this.dataSource = arr;
    },
    filterData(arr: any) {
      arr.forEach((item: any) => {
        if (item.children && item.children.length > 0) {
          this.filterData(item.children);
        } else {
          delete item.children;
        }
      });
      return arr;
    }
  }
});
